import React, { Component } from "react";
import Layout from "../../hoc/layout/layout";
import BannerImg from "../../assets/images/highlight/bannerImage.png";
import Highlight1 from "../../assets/images/highlight/highlight-1-new.png";
import Highlight2 from "../../assets/images/highlight/highlight-2-new.png";
import Highlight3 from "../../assets/images/highlight/highlight-3-new.png";
import Highlight4 from "../../assets/images/highlight/highlight-4-new.png";
import Highlight5 from "../../assets/images/highlight/highlight-5-new.png";
import Highlight6 from "../../assets/images/highlight/highlight-6-new.png";
import Highlight7 from "../../assets/images/highlight/highlight-7-new.png";
import Highlight8 from "../../assets/images/highlight/highlight-8-new.png";
import Highlight9 from "../../assets/images/highlight/highlight-9-new.png";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { HighlightPopup } from "../../components/highlightPopup/highlightPopup";
import { LazyLoadImage } from "react-lazy-load-image-component";
import pinwheel from "../../assets/images/pinwheel.gif";
// import ImageLoader from "react-load-image";
import $ from "jquery";

const hasWindow = typeof window !== "undefined" ? true : false;
if (hasWindow) {
  window.loader = true;
}

class Highlight extends Component {
  state = {
    userTokenMain: "",
    allhightlights: [
      {
        image: Highlight1,
        title:
          "Welcome Reception/Movie Screening",
        subtitle:
          "The City Beautiful greets Sorors on Sunday at 7:30 pm.",
        description:
          "Sorors are welcomed to the Boule and invited to watch Twenty Pearls.",
        full_description:
          "Sorors are welcomed to the Boule and invited to watch Twenty Pearls.",
      },
      // {
      //   image: Highlight2,
      //   title:
      //     "Coming Soon",
      //   subtitle:
      //     "Coming Soon",
      //   description:
      //     "Coming Soon",
      //   full_description:
      //     "Coming Soon",
      // },
      {
        image: Highlight3,
        title:
          "EAF Scholarship & Awards Breakfast",
        subtitle:
          "Magic of Excellence In Scholarship & Giving will be held on Wednesday at 7:00 am.",
        description:
          "Please join the Educational Advancement Foundation, Inc. as we celebrate our 2022 Awardees.",
        full_description:
          "Please join the Educational Advancement Foundation, Inc. as we celebrate our 2022 Awardees.",
      },
      {
        image: Highlight4,
        title:
          "Undergraduate Luncheon",
        subtitle:
          "Soror Fig O'Reilly keynotes the Undergraduate Luncheon on Wednesday at noon.",
        description:
          "The former Miss Universe Ireland shares her journey to inspire our Undergraduate Sorors.",
        full_description:
          "The former Miss Universe Ireland shares her journey to inspire our Undergraduate Sorors.",
      },
      {
        image: Highlight5,
        title:
          "Closing Gala",
        subtitle:
          "Close out the Boule and the Excellence Administration on Thursday at 7:00 pm.",
        description:
          "\"Just Can't Say Goodbye\" to the Excellence Administration without the illustrious Peabo Bryson.",
        full_description:
          "\"Just Can't Say Goodbye\" to the Excellence Administration without the illustrious Peabo Bryson.",
      },
      {
        image: Highlight6,
        title:
          "Social Justice Forum",
        subtitle:
          "Hear rivieting discussion on the racial and scoial injustice facing our society on Tuesday at 8:30 am.",
        description:
          "Supreme Basileus Glenda Glover has a one-on-one with Social Justice Leader Reverend Al Sharpton.",
        full_description:
          "Supreme Basileus Glenda Glover has a one-on-one with Social Justice Leader Reverend Al Sharpton.",
      },
      {
        image: Highlight7,
        title:
          "Voting Rights Forum",
        subtitle:
          "Voting Rights experts join us  on Tuesday at 3:00 pm.",
        description:
          "Sorors Cheri Beasley, Tamika Mallory, and Glynda Carr speak on matters that affect our voting rights.",
        full_description:
          "Sorors Cheri Beasley, Tamika Mallory, and Glynda Carr speak on matters that affect our voting rights.",
      },
      {
        image: Highlight8,
        title:
          "Sisterhood Luncheon",
        subtitle:
          "Star Jones joins the Sisterhood Luncheon on Monday at noon.",
        description:
          "Award-Winning Attorney, Author, Advocate & Media Personality joins Supreme Basileus Glenda Glover for a heart-to-heart.",
        full_description:
          "Award-Winning Attorney, Author, Advocate & Media Personality joins Supreme Basileus Glenda Glover for a heart-to-heart.",
      },
      // {
      //   image: Highlight9,
      //   title:
      //     "DPGS",
      //   subtitle:
      //     "",
      //   description:
      //     "",
      //   full_description:
      //     "",
      // },

    ],
    selectedHighlight: "",
    popupToggle: false,
  };
  popupHandler = (data) => {
    this.setState({
      selectedHighlight: data,
      popupToggle: true,
    });
  };

  componentDidMount() {
    if (hasWindow) {
      $(".highlight-section .highlight-colm-box").click(function () {
        $("body").addClass("active");
      });
      $(".main-close").click(function () {
        $("body").removeClass("active");
      });
    }
    let userToken = localStorage.getItem("userToken");
    this.setState({
      userTokenMain: userToken,
    });
  }

  render() {
    return (
      <div>
        {/* <div className="loader-box"></div> */}
        <HighlightPopup
          popupHandler={() => this.setState({ popupToggle: false })}
          selectedHighlight={this.state.selectedHighlight}
          popupToggle={this.state.popupToggle}
        />
        <div className="innerpage-sec highlight-section">
          <div className="overlay">
            <img src={BannerImg} alt="" />
          </div>

          <div className="section-header">
            <div className="inner">
              <h1>HIGHLIGHTS</h1>
              <p>
                Click on any of the featured events below to learn more.
              </p>
              {/* <a
                href={`https://events.aka1908.net/21991000/${this.state.userTokenMain}?redirect=recordings`}
                className="btn btn-green more-info"
                target="_blank"
              >
                WATCH RECORDINGS
              </a> */}
            </div>
          </div>

          {/* <div className="colm-row">
            {this.state.allhightlights.length > 0
              ? this.state.allhightlights.map((data, key) => (
                  <div
                    key={key}
                    onClick={() => this.popupHandler(data)}
                    className="highlight-colm-box"
                  >
                    <div className="inner-colm">
                      <a href="#" className="read-more">
                        <figure className="custom-img-box">
                          {data.image ? (
                            <img src={data.image} alt="" />
                          ) : (
                            <img src={pinwheel} alt="" />
                          )}
                        </figure>
                      </a>
                      <div className="custom-txt-box">
                        <h4 className="title">{data.title}</h4>
                        <p className="subtitle">{data.subtitle}</p>
                        <p>{data.description}</p>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </div> */}
          <div className="colm-row"></div>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 270: 1, 480: 2, 1190: 2, 1200: 3 }}
          >
            <Masonry gutter={15}>
              {this.state.allhightlights.length > 0
                ? this.state.allhightlights.map((data, key) => (
                  <div
                    key={key}
                    onClick={() => this.popupHandler(data)}
                    className="highlight-colm-box"
                  >
                    <div className="inner-colm">
                      <figure className="custom-img-box">
                        {data.image ? (
                          <img src={data.image} alt="" />
                        ) : (
                          <img src={pinwheel} alt="" />
                        )}
                      </figure>

                      <div className="custom-txt-box">
                        <h4 className="title">{data.title}</h4>
                        <p className="subtitle">{data.subtitle}</p>
                        <p>{data.description}</p>
                      </div>
                    </div>
                  </div>
                ))
                : null}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    );
  }
}

export default Highlight;
